module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Dintikon-1f76e3123a1acab21d9e173f2fcb4e5b.svg";